module.exports = __webpack_public_path__ + "static/unicred-cover-5bded54419233139fdcf703ffd0285e4.png";